module.exports = __webpack_public_path__ + "static/3-14d74d55a57767126305a9bbb6607981.jpg";